<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('send_pagements.edit_payment')" :close-on-click-modal="false" width="910px">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('send_pagements.single_payment_details') }}
      </div>
      <div class="section-tip">
        {{ $t('tips.select_receiving_channel_and_fill_payments_details') }}
      </div>
      <div class="form-container">
        <el-form ref="singleDisbursementForm" :model="singleDisbursementForm" status-icon label-position="top">

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('merchantAccount.recipient_channel')"
                prop="code"
                :rules="[
                  { required: true, message: 'Receiving channel cannot be empty', trigger: 'blur'},
                ]"
              >
                <el-select v-model="singleDisbursementForm.code" filterable class="select-item" clearable @change="disbursementChannelChange">
                  <el-option
                    v-for="(item,index) in bankList"
                    :key="index"
                    :label="item.name_with_full_bank"
                    :value="item.bank_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">

              <el-form-item
                :label="$t('send_pagements.recipient_account_number')"
                prop="account_no"
                :rules="[
                  { required: true, message: 'Recipient account number cannot be empty', trigger: 'blur'},
                  { validator: checkoutAccountNo, trigger: ['blur','change']}
                ]"
              >
                <el-input v-model="singleDisbursementForm.account_no" placeholder="Enter recipient account number" class="search-frame" maxlength="50" autocomplete="off" show-word-limit clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('merchantAccount.recipient_name')"
                prop="account_name"
                :rules="[
                  { required: true, message: 'Recipient name cannot be empty', trigger: 'blur'},
                  { validator: checkWhitespace, trigger: 'blur'}
                ]"
              >
                <el-input
                  v-model="singleDisbursementForm.account_name"
                  placeholder="Enter recipient name"
                  class="search-frame"
                  autocomplete="off"
                  clearable
                  maxlength="100"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">

              <el-form-item
                :label="$t('components.amount')"
                prop="amount"
                :rules="[
                  { required: true, message: 'Amount cannot be empty', trigger: ['blur', 'change']},
                  { validator: checkAmount, trigger: ['blur', 'change'] }
                ]"
              >
                <el-input v-model="singleDisbursementForm.amount" type="text" placeholder="Enter amount" class="input-item" autocomplete="off" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item
                :label="$t('customerService.email_address')"
                prop="email"
                :rules="[
                  { type: 'email', message: 'Please input the correct email', trigger: ['blur', 'change'] },
                ]"
              >
                <el-input v-model.trim="singleDisbursementForm.email" placeholder="Enter email address" class="search-frame" autocomplete="off" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('data.remark')">
                <el-input
                  v-model="singleDisbursementForm.remark"
                  type="textarea"
                  autocomplete="off"
                  placeholder="Enter your message here"
                  maxlength="256"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { updateDisbursementInfo } from '@/api/online-transaction/online-transaction.js'
import { fetchDisbursementAllCodeList } from '@/api/components/components.js'

export default {
  name: 'Single_Disbursement_Edit_Modal',
  data() {
    this.BANK = 1
    this.checkWhitespace = (rule, value, callback) => {
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      callback()
    }
    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      if (!this.$store.getters.isCurIDCountry && value > 50000) {
        return callback(new Error('Currently up to 50000'))
      }
      this.$commonFn.validateFormAmount({rule, value, callback})

      if (value > this.balance) {
        return callback(new Error('Insufficient balance!'))
      }
      callback()
    }
    this.checkoutAccountNo = (rule, value, callback) => {
      const bankItem = this.bankList.find(item => item.bank_name === this.singleDisbursementForm.code) || {}

      if (/\s/g.test(value)) {
        return callback(new Error('The input value cannot contain spaces'))
      }
      if (value !== '0' && !Number(value)) {
        return callback(new Error('Only can input number'))
      }

      if (bankItem.bank_type === 2) {
        if (!/(09)\d{9}$/.test(value)) {
          return callback(new Error(' Pls input the correct Recipient account number and start with 09'))
        }
      }
      if (value.trim() !== value) {
        return callback(new Error('Please make sure there are no spaces at the beginning or end of your input.'))
      }
      if (value.length && value.length < 5) {
        return callback(new Error('Please input between 5 to 50 characters.'))
      }
      callback()
    }
    return {
      bankList: [],
      singleDisbursementForm: {
        amount: 0,
        account_no: null
      },
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false
    }
  },
  created() {
    this.getAllBank()
  },
  methods: {
    getAllBank() {
      fetchDisbursementAllCodeList().then(res => {
        if (res.code === 10000) {
          const list = res.data
          list.map(item => {
            item.name_with_full_bank = item.bank_code
            if (item.bank_type === this.BANK) {
              item.name_with_full_bank = item.bank_code + ' - ' + item.full_name
            }
            return item
          })
          this.bankList = list
        }
      })
    },
    // 改变弹框状态
    changModalStatus(config) {
      this.dialogVisible = config.status
      if (config.value) {
        this.singleDisbursementForm = { disbursement_number: null, ...config.value }
      }
      this.$nextTick(() => {
        if (config.status) {
          this.$refs.singleDisbursementForm.validate()
        }
      })
    },
    onClickSubmitBtn() {
      this.$refs.singleDisbursementForm.validate((valid) => {
        if (valid) {
          this.submiting = true
          const params = [this.singleDisbursementForm]
          updateDisbursementInfo(params).then(res => {
            if (res.code === 10000) {
              this.dialogVisible = false
              this.$emit('getDisbursementRefernceDetail')
            }
          }).finally(() => {
            this.submiting = false
          })
        }
      })
    },
    disbursementChannelChange() {
      if (this.singleDisbursementForm.code) {
        this.$nextTick(function() {
          this.$refs['singleDisbursementForm'].clearValidate(['code'])
        })
      }
      this.singleDisbursementForm.account_no = null
      this.$nextTick(function() {
        this.$refs['singleDisbursementForm'].clearValidate(['account_no'])
      })
    }
  }
}
</script>

<style scoped>
.select-item{
  width: 100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  width: 500px;
  height: 40px;
  border-radius: 4px;
}
</style>
